"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * IScoreGolfPlus Development
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 1.1.56-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScoreCardToJSON = exports.ScoreCardFromJSONTyped = exports.ScoreCardFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function ScoreCardFromJSON(json) {
    return ScoreCardFromJSONTyped(json, false);
}
exports.ScoreCardFromJSON = ScoreCardFromJSON;
function ScoreCardFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'gross': json['gross'],
        'net': json['net'],
        'grossToPar': json['grossToPar'],
        'netToPar': json['netToPar'],
        'stableford': !runtime_1.exists(json, 'stableford') ? undefined : json['stableford'],
        'netStableford': !runtime_1.exists(json, 'netStableford') ? undefined : json['netStableford'],
        'holes': (runtime_1.mapValues(json['holes'], _1.ScoreFromJSON)),
    };
}
exports.ScoreCardFromJSONTyped = ScoreCardFromJSONTyped;
function ScoreCardToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'gross': value.gross,
        'net': value.net,
        'grossToPar': value.grossToPar,
        'netToPar': value.netToPar,
        'stableford': value.stableford,
        'netStableford': value.netStableford,
        'holes': (runtime_1.mapValues(value.holes, _1.ScoreToJSON)),
    };
}
exports.ScoreCardToJSON = ScoreCardToJSON;
